export default "__VITE_ASSET__DS5Erdn9__"